import { render, staticRenderFns } from "./PublicWrapper.vue?vue&type=template&id=8324897a"
import script from "./PublicWrapper.vue?vue&type=script&lang=js"
export * from "./PublicWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports